import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import {
  mdiAccountMultipleOutline,
  mdiCloudPlusOutline,
  mdiClouds,
  mdiEmailOutline,
  mdiFormatAlignJustify,
  mdiInformationOutline,
  mdiLan,
  mdiLayersTriple,
  mdiMenuDown,
  mdiMinus,
  mdiPlus,
  mdiTrayArrowDown,
  mdiWeb,
  mdiArchiveArrowDownOutline,
  mdiKeyOutline,
  mdiMenu,
  mdiShareVariantOutline,
  mdiRadio,
  mdiBookOpenPageVariantOutline,
  mdiSticker,
  mdiCloudUploadOutline,
  mdiMagnify,
  mdiStickerOutline,
  mdiVectorRectangle,
  mdiSnowflake,
  mdiChevronDoubleLeft,
  mdiChevronDoubleRight,
  mdiTrafficLightOutline,
  mdiCheckBold,
  mdiArrowExpandVertical,
  mdiNotebookOutline,
  mdiChartLine,
  mdiFileDocument,
  mdiFileDocumentOutline,
  mdiCardText,
  mdiCardTextOutline,
  mdiCached,
  mdiFileDocumentCheckOutline,
  mdiShieldKeyOutline,
  mdiAlertOutline,
  mdiViewDashboardOutline,
  mdiMapMarkerRadiusOutline,
  mdiFormatVerticalAlignTop,
  mdiSignalCellularOutline,
  mdiFormatListBulleted,
  mdiCogOutline,
  mdiCalendarBlank,
  mdiLanConnect,
  mdiMapMarkerRadius,
  mdiSitemapOutline,
  mdiTuneVariant,
  mdiArrowDecisionOutline,
  mdiTransitConnectionHorizontal,
  mdiSignal,
  mdiServerNetwork,
  mdiHubOutline,
  mdiCardAccountDetailsOutline,
  mdiInformationSlabCircleOutline,
  mdiCalendarMonth,
  mdiGestureTap,
  mdiClockStart,
  mdiClockEnd,
  mdiCalendarAlert,
  mdiTransitConnection,
  mdiSecurityNetwork,
  mdiCloudKey,
  mdiRobot,
  mdiArrowExpandLeft,
  mdiArrowExpandRight,
  mdiDelete,
  mdiClose,
  mdiThumbUp,
  mdiThumbUpOutline,
  mdiThumbDown,
  mdiThumbDownOutline,
  mdiSend,
  mdiServer,
  mdiAlertCircle,
  mdiCloseCircle,
  mdiChevronUp,
  mdiChevronDown,
  mdiHelpCircleOutline,
  mdiCheckCircleOutline,
  mdiCheckCircle,
} from "@mdi/js";
import { VIcon } from "vuetify/components/VIcon";
import "@/styles/main.scss";

const vuetify = createVuetify({
  components: { VIcon }, // VIconはGlobal導入(vue-sidebar-menuの中に使うため)
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#0d47a1",
          info: "#17a2b8",
          error: "#dc3545",
          gray: "#e9ecef",
          warning: "#ffc107",
          success: "#28a745",
        },
      },
    },
  },
  // Icon探す：https://vuetifyjs.com/en/features/icon-fonts/#mdi-icon-search
  icons: {
    defaultSet: "mdi",
    aliases: {
      ...aliases,
      // ここ以降は導入したICON
      mdiAccountMultipleOutline,
      mdiEmailOutline,
      mdiFormatAlignJustify,
      mdiInformationOutline,
      mdiMenuDown,
      mdiMenu,
      mdiTrayArrowDown,
      mdiLayersTriple,
      mdiClouds,
      mdiLan,
      mdiCloudPlusOutline,
      mdiPlus,
      mdiMinus,
      mdiWeb,
      mdiArchiveArrowDownOutline,
      mdiKeyOutline,
      mdiShareVariantOutline,
      mdiRadio,
      mdiBookOpenPageVariantOutline,
      mdiSticker,
      mdiCloudUploadOutline,
      mdiMagnify,
      mdiStickerOutline,
      mdiVectorRectangle,
      mdiSnowflake,
      mdiChevronDoubleLeft,
      mdiChevronDoubleRight,
      mdiTrafficLightOutline,
      mdiCheckBold,
      mdiArrowExpandVertical,
      mdiNotebookOutline,
      mdiChartLine,
      mdiFileDocument,
      mdiFileDocumentOutline,
      mdiCardText,
      mdiCardTextOutline,
      mdiCached,
      mdiFileDocumentCheckOutline,
      mdiShieldKeyOutline,
      mdiAlertOutline,
      mdiViewDashboardOutline,
      mdiMapMarkerRadiusOutline,
      mdiFormatVerticalAlignTop,
      mdiSignalCellularOutline,
      mdiFormatListBulleted,
      mdiCogOutline,
      mdiCalendarBlank,
      mdiLanConnect,
      mdiMapMarkerRadius,
      mdiSitemapOutline,
      mdiTuneVariant,
      mdiArrowDecisionOutline,
      mdiTransitConnectionHorizontal,
      mdiSignal,
      mdiServerNetwork,
      mdiHubOutline,
      mdiCardAccountDetailsOutline,
      mdiInformationSlabCircleOutline,
      mdiCalendarMonth,
      mdiGestureTap,
      mdiClockStart,
      mdiClockEnd,
      mdiCalendarAlert,
      mdiTransitConnection,
      mdiSecurityNetwork,
      mdiCloudKey,
      mdiRobot,
      mdiArrowExpandLeft,
      mdiArrowExpandRight,
      mdiDelete,
      mdiClose,
      mdiThumbUp,
      mdiThumbUpOutline,
      mdiThumbDown,
      mdiThumbDownOutline,
      mdiSend,
      mdiServer,
      mdiAlertCircle,
      mdiCloseCircle,
      mdiChevronUp,
      mdiChevronDown,
      mdiHelpCircleOutline,
      mdiCheckCircleOutline,
      mdiCheckCircle,
    },
    sets: {
      mdi,
    },
  },
  defaults: {
    VBtn: {
      variant: "flat",
    },
    VTextField: {
      variant: "outlined",
      density: "compact",
    },
    VRow: {
      dense: true,
    },
    VTextarea: {
      variant: "outlined",
      density: "compact",
    },
    VSelect: {
      variant: "outlined",
      density: "compact",
      noDataText: "データがありません",
    },
    VRadioGroup: {
      color: "primary",
    },
    VAutocomplete: {
      noDataText: "データがありません",
      density: "compact",
    },
    VAlert: {
      density: "compact",
    },
    VCheckboxBtn: {
      color: "primary",
    },
  },
});

export default vuetify;
